import { ChartConfigurationProvider } from "@/contexts/ChartConfiguration";
import {
  DiscreteChartCard,
  GenesAllelesChartCard,
  GradientsChartsCard,
  SegmentedChartChard,
  UnknownChartCard
} from "@/tpo/ChartCards";

export default function DatapointCharts({ children, datapoint }) {
  if (datapoint.chartConfiguration?.chartType === "GRADIENT_CHART") {
    return (
      <ChartConfigurationProvider value={datapoint.chartConfiguration}>
        <GradientsChartsCard datapoint={datapoint}>{children}</GradientsChartsCard>
      </ChartConfigurationProvider>
    );
  } else if (datapoint.chartConfiguration?.chartType === "DISCRETE_CHART") {
    return (
      <ChartConfigurationProvider value={datapoint.chartConfiguration}>
        <DiscreteChartCard result={datapoint}>{children}</DiscreteChartCard>
      </ChartConfigurationProvider>
    );
  } else if (datapoint.chartConfiguration?.chartType === "SEGMENTED_CHART") {
    return (
      <ChartConfigurationProvider value={datapoint.chartConfiguration}>
        <SegmentedChartChard datapoint={datapoint}>{children}</SegmentedChartChard>
      </ChartConfigurationProvider>
    );
  } else if (datapoint.datapoint.chartType === "GENES_ALLELES_CHART") {
    return (
      <ChartConfigurationProvider value={datapoint.chartConfiguration}>
        <GenesAllelesChartCard datapoint={datapoint}>{children}</GenesAllelesChartCard>
      </ChartConfigurationProvider>
    );
  }
  return (
    <ChartConfigurationProvider value={datapoint.chartConfiguration}>
      <UnknownChartCard result={datapoint}>{children}</UnknownChartCard>
    </ChartConfigurationProvider>
  );
}
